export default "__VITE_ASSET__DdvbTyet__"